import {Injectable} from '@angular/core';
import {Params} from "@angular/router";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UrlEntryService {

    allParams$: BehaviorSubject<Params> = new BehaviorSubject<Params>({})

    constructor() {
    }

    storeUrlInfos(urlParams: Params, merge = true) {

        if (merge) {
            this.allParams$.next({
                ...this.allParams$.value,
                ...urlParams,
            });
        } else {
            this.allParams$.next(urlParams);
        }

    }

    getParams(): Params {
        return this.allParams$.value;
    }

}
